<template>
  <div class="bank-soal-sheet-per-option">

    <modal-confirm :active.sync="dialogSendJawaban"
                   :skipImmediateClose="false"
                   :isLoading="isLoading"
                   :title="`Konfirmasi kirim jawaban`"
                   @confirm="() => doSendJawabanBankSoal()">
      Apakah ada yakin akan mengirim jawaban soal ?
    </modal-confirm>

    <div class="title-soal">
      <div class="info-soal">
        <div :key="index" class="info-soal-item" v-for="(item, index) in infoLembarSoal">
          <div class="field has-addons">
            <div class="control">
              <a class="button is-dark is-outlined">
                {{ $t('label.' + item.label) }}
              </a>
            </div>
            <div class="control is-expanded">
              <input class="input is-white" type="text" :value="item.value" disabled>
            </div>
          </div>
        </div>
      </div>
    </div>

    <card-item :class="`font-size-${ukuranFont}`" :header="header" rounded type="info">
      <div class="toolbar media">
        <div class="media-content">
          <g-field is-grouped>
            <div class="control">
              <p>Ukuran Font</p>
            </div>
            <div :key="font"
                 class="control" v-for="font in ukuranFonts">
              <g-button :class="font"
                        :type="ukuranFont === font ? 'info' : ''"
                        @click="ukuranFont = font">
                A
              </g-button>
            </div>
          </g-field>
        </div>
        <div class="media-right" v-if="!($scopedSlots.default || $slots.default)">
          <g-field is-grouped>
            <div class="control">
              <g-dropdown class="dropdown-search-input" position="bottom-left">
                <g-button class="has-icon" is-outlined
                          slot="trigger" type="link">
                  <span class="icon"><i class="far fa-info"></i></span>
                  <span>Daftar Soal dan Jawaban</span>
                </g-button>

                <template>
                  <div class="info-preview-soal">
                    <p class="title is-6">Nomor Soal</p>
                  </div>
                  <div :key="previewSoalKey"
                       class="preview-soal columns is-multiline">
                    <div :key="soal.nomor" v-show="soal.show"
                         class="column is-3" v-for="soal in previewSoals">
                      <g-button :type="soal.nomor === aktifNomor ? 'info' : ''"
                                @click="goToSoal(soal.nomor)">
                        {{ soal.nomor }}
                      </g-button>
                      <div class="dot-jawaban" v-if="soal.jawaban && soal.jawaban !== ''">
                        {{ soal.jawaban.toUpperCase() }}
                      </div>
                    </div>
                  </div>
                </template>
              </g-dropdown>
            </div>
            <div class="control">
              <g-button @click="logout"
                        type="danger">
                <span>Keluar</span>
                <span class="icon"><i class="far fa-power-off"></i></span>
              </g-button>
            </div>
          </g-field>
        </div>
      </div>

      <template v-if="$scopedSlots.default || $slots.default">
        <slot></slot>
      </template>

      <template v-else>
        <div class="content-soal">

          <div class="content" :class="ukuranFont" style="font-size: medium"
               v-html="soals[index].soal">
          </div>

          <div class="columns is-multiline">
            <div :key="wIndex" class="column is-6" v-for="(word, wIndex) in options">
              <div class="media" v-if="soals[index]['pilihan_'+word] != ''">
                <div class="media-left">
                  <g-field :class="ukuranFont" class="field-option" is-grouped>
                    <div class="control tooltip" data-tooltip="Klik opsi ini untuk men set sebagai jawaban"
                         v-if="soals && soals[index]">
                      <g-radiobutton :name="`option-${index}`" :native-value="word"
                                     @on-selected="onSelectOption"
                                     v-model="soals[index].jawaban"/>
                    </div>
                    <div class="control"><p>{{ word.toUpperCase() }}.</p></div>
                  </g-field>
                </div>
                <div class="media-content">
                  <div :class="ukuranFont" class="content" style="font-size: medium"
                       v-html="soals[index]['pilihan_'+word]">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="footer-soal level">
          <div class="level-item">
            <g-button :disabled="aktifNomor === 1" @click="goToSoal(aktifNomor - 1)"
                      type="danger">
              <span class="icon"><i class="far fa-chevron-left"></i></span>
              <span>Soal Sebelumnya</span>
            </g-button>
          </div>
          <div class="level-item" v-if="soals.length == aktifNomor">
            <g-button type="success" @click="doDialogSendJawaban()" :is-loading="isLoading">
              <span>Kirim Jawaban</span>
              <span class="icon"><i class="far fa-send"></i></span>
            </g-button>
          </div>
          <div class="level-item">
            <g-button :disabled="aktifNomor === soals.length"
                      @click="goToSoal(aktifNomor + 1)"
                      type="primary">
              <span>Soal Selanjutnya</span>
              <span class="icon"><i class="far fa-chevron-right"></i></span>
            </g-button>
          </div>
        </div>

      </template>
    </card-item>

  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Container } from 'annotation';
import BankSoal from "../../entity/BankSoal";
import AsesmenPendaftar from "../../entity/AsesmenPendaftar";
import {toListFormated} from "../../util/Underscore";
import GField from "./common/field/GField.vue";
import GRadiobutton from "./common/radio-button/GRadiobutton.vue";
import GButton from "./common/button/GButton.vue";
import GSelect from "./common/select/GSelect.vue";
import CardItem from "./CardItem.vue";
import Soal from "../../entity/Soal";
import {getJenisKelamin, getPenerimaDana} from "../../util/PluralVariabels";
import JawabanBankSoal from "../../entity/JawabanBankSoal";
import Response from "../../service/Response";
import BankSoalService from "../../service/BankSoalService";
import Notification from "../../Notification";
import Authentication from "../../Authentication";
import ModalConfirm from "./ModalConfirm.vue";
import GDropdown from "./common/dropdown/GDropdown.vue";

@Component({
  components: {GDropdown, ModalConfirm, CardItem, GSelect, GButton, GRadiobutton, GField}
})
export default class BankSoalSheetPerOptions extends Vue {

  @Prop({type: AsesmenPendaftar, default: new AsesmenPendaftar()})
  public asesmen: AsesmenPendaftar;

  @Prop({type: BankSoal, default: new BankSoal()})
  public bankSoal: BankSoal;

  @Prop({type: BankSoal, default: Array<Soal>()})
  public soals: Array<Soal>;

  public aktifNomor: number = 1;

  public ukuranFonts: Array<string> = ['small', '', 'large', 'very-large'];

  public ukuranFont: string = this.ukuranFonts[1];

  public options: Array<string> = ["a", "b", "c", "d", "e"];

  public get bankSoalService(): BankSoalService {
    return Container.get(BankSoalService);
  }

  public jawabanBankSoal: JawabanBankSoal = new JawabanBankSoal();

  public isLoading: boolean = false

  public dialogSendJawaban: boolean = false;

  public previewSoalKey: string = Math.random().toString();

  public get infoLembarSoal() {
    let param = {
      nomor: this.asesmen.nomor,
      nama: this.asesmen.nama_lengkap,
      jenis_kelamin: getJenisKelamin(this.asesmen.jenis_kelamin),
      orang_tua: this.asesmen.orang_tua,
      pendidikan: getPenerimaDana(this.asesmen.pendidikan),
      sekolah_asal: this.asesmen.sekolah_asal,
    };

    return toListFormated(param);
  }

  public get previewSoals() {
    return this.soals.reduce((accu: Array<any>, item: Soal, index: number) => {
      const hasJawaban = this.soals[index].jawaban;
      let jawaban = "";
      if (hasJawaban) {
        jawaban = this.soals[index].jawaban;
      }

      accu.push({nomor: index + 1, jawaban: jawaban, show: true});
      return accu;
    }, []);
  }

  public get index() {
    return this.aktifNomor - 1;
  }

  public get header() {
    const title = `Pertanyaan ke ${this.aktifNomor}`;

    return {title, icon: 'far fa-list-alt'}
  }

  public goToSoal(no: number = 1) {
    if (no !== 0 && no !== this.soals.length + 1) {
      this.aktifNomor = no;
    }
  }

  public async logout() {
    Authentication.removeAsesmen();

    // Go to home page
    window.location.href = '/';
  }

  public onSelectOption() {
    //const value = this.soals[this.index]
  }

  public async doDialogSendJawaban() {
    let valid = true
    this.soals.forEach(value => {
      if (value.jawaban == "") {
        valid = false
      }
    })

    if (!valid) {
      Notification.showNotification({
        text: 'Belum semua terjawab',
        title: `Terdapat soal yang belum ada jawab, Silahkan cek kembali`
      }, true);
    } else {
      this.dialogSendJawaban = true
    }
  }

  public async doSendJawabanBankSoal() {
    this.isLoading = false;
    this.jawabanBankSoal.bank_soal_id = this.bankSoal.id
    this.jawabanBankSoal.nomor = this.asesmen.nomor
    this.jawabanBankSoal.nama_lengkap = this.asesmen.nama_lengkap
    this.jawabanBankSoal.jenis_kelamin = this.asesmen.jenis_kelamin
    this.jawabanBankSoal.orang_tua = this.asesmen.orang_tua
    this.jawabanBankSoal.sekolah_asal = this.asesmen.sekolah_asal
    this.jawabanBankSoal.jawabans = this.soals;
    let response: Response = await this.bankSoalService.doSendJawaban(this.jawabanBankSoal);
    if (response.statusResponse == 200) {
      Authentication.removeAsesmen();

      // Go to home page
      window.location.href = '/';
    } else {
      Notification.showNotification({
        text: 'Gagal kirim jawaban',
        title: `Gagal mengirim jawaban, Silahkan hubungi admin`
      }, true);
    }

    this.isLoading = false;
  }

}
</script>

<style lang="scss">
@import "../../style/variables_function";

.bank-soal-sheet-per-option {
  .card-content {
    padding: 1.25rem;

    .has-no-content {
      margin: 1.25rem 0;
    }
  }

  .toolbar {
    margin: -1.25rem;
    padding: 1.25rem;
    background-color: $grey-lighten;

    .media-content {
      .is-grouped {
        align-items: center;
      }

      .button {
        width: 33px;
        height: 33px;
      }

      .button.small {
        font-size: .8rem;
      }

      .button.large {
        font-size: 1.25rem;
      }

      .button.very-large {
        font-size: 1.50rem;
      }
    }

    .media-right {
      .dropdown-menu {
        width: 240px;
        margin-top: .5rem;

        .dropdown-content {
          overflow: auto;
        }
      }

      .info-preview-soal {
        background-color: $info;
        margin: -.5rem 0 0;
        padding: .75rem;

        p {
          color: white;
        }
      }

      .preview-soal {
        margin: 0;
        max-height: 200px;

        .column.is-3 {
          position: relative;
          text-align: center;
        }

        .dot-jawaban {
          position: absolute;
          top: 5px;
          right: 5px;
          background-color: $danger;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          color: white;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .dot-ragu2 {
          position: absolute;
          top: 5px;
          right: 5px;
          background-color: $yellow;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          color: white;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .content-soal {
    margin: 0 0 1.75rem;

    .field-option {
      align-items: center;
      padding: .25rem .75rem .25rem .5rem;
      border-radius: 12px;
      border: 1.5px solid;

      .control.tooltip {
        display: flex;
      }
    }

    .content.small p, .field-option.small p {
      font-size: .8rem;
    }

    .content.large p, .field-option.large p {
      font-size: 1.25rem;
    }

    .content.very-large p, .field-option.very-large p {
      font-size: 1.50rem;
    }
  }

  .footer-soal {
    margin: 0 -1.25rem -1.25rem;
    padding: 1.25rem;
    background-color: $grey-lighten;

    .level-item {
      &:first-child {
        justify-content: flex-start;
      }

      &:last-child {
        justify-content: flex-end;
      }
    }
  }
}
</style>
